import React from 'react';
import { connect } from 'react-redux';
import { UserSettings } from '@leverege/ui-redux';
import { Popup } from '@leverege/ui-elements';
import { Config } from '@leverege/plugin';
import I18N from '@leverege/i18n';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const {
  t,
  tf,
  tfArray
} = I18N.ns('molten.views.userSettings.LoadFromVersions');
const versionRenderer = ({
  context,
  versions,
  onClose
}) => {
  const {
    editor
  } = context;
  if (!versions?.items?.length) {
    return null;
  }
  const load = ({
    data
  }) => {
    editor.onChange({
      value: data
    });
    if (onClose) onClose();
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Popup.Header, {
      children: t('title')
    }, "versionsHeader"), versions?.items?.map(v => /*#__PURE__*/_jsx(Popup.Item, {
      onClick: load,
      eventData: v.data,
      children: v.name
    }, v.name))]
  });
};
export default {
  id: 'molten.userSetting.titleLeft.loadFrom.versions',
  name: tf('name'),
  matches: {
    use: 'titleLeft',
    client: ['UserSettingsEditor', 'ExportSettingsEditor']
  },
  handles: context => {
    return !context.simple;
  },
  layout: {
    group: ['loadFrom'],
    groupIcons: [() => {
      return Config.get('Main', 'loadIcon', 'fa fa-download fa-fw');
    }],
    groupNames: tfArray('groupNames'),
    sort: 'zzzz'
  },
  customComponent: connect((state, props) => {
    const {
      context: {
        versionsPath
      }
    } = props;
    return {
      versions: UserSettings.getVersions(state, versionsPath, {
        returnPromise: false
      })
    };
  })(versionRenderer)
};